(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-pro-max-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('dh-apex-reveal')) return;

    class DHApexReveal extends HTMLElement {
      connectedCallback() {
        if (this.dhConnected) return;
        this.dhConnected = true;
        this.dhAbort = new AbortController();
        this.dhVideo = this.querySelector('video');
        this.dhImage = this.querySelector('img');
        this.dhMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.dhVisible = false;
        this.dhBusy = false;
        this.dhLoaded = false;
        this.dhTarget = Number(this.dataset.settle) || 5.4;
        this.dhLastTime = 0;
        this.dhLastProgress = performance.now();

        // A reattached or re-ordered instance stays on its still, never replays.
        if (this.dhFinished || this.dhStarted || !this.dhVideo ||
            this.dataset.animate !== 'true' || this.dhMotion.matches ||
            navigator.connection?.saveData) {
          this.dhFinish();
          return;
        }

        this.dataset.state = 'waiting';
        const signal = this.dhAbort.signal;
        this.dhVideo.muted = true;
        this.dhVideo.defaultMuted = true;
        this.dhVideo.loop = false;
        this.dhVideo.addEventListener('error', () => this.dhFinish(), { signal });
        this.dhVideo.addEventListener('ended', () => this.dhFinish(), { signal });
        this.dhVideo.addEventListener('timeupdate', () => this.dhCheckFrame(), { signal });
        this.dhVideo.addEventListener('canplay', () => this.dhTryPlay(), { signal });
        this.dhVideo.addEventListener('progress', () => this.dhTryPlay(), { signal });
        document.addEventListener('visibilitychange', () => this.dhVisibility(), { signal });
        this.dhMotion.addEventListener('change', () => {
          if (this.dhMotion.matches) this.dhFinish();
        }, { signal });

        // Fetch near the viewport; start only when meaningfully on-screen.
        if ('IntersectionObserver' in window) {
          this.dhPreloadObserver = new IntersectionObserver((entries) => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.dhPrepare();
              this.dhPreloadObserver.disconnect();
            }
          }, { rootMargin: '400px 0px' });
          this.dhPlayObserver = new IntersectionObserver((entries) => {
            this.dhVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
            this.dhVisibility();
          }, { threshold: [0, 0.2] });
          this.dhPreloadObserver.observe(this);
          this.dhPlayObserver.observe(this);
        } else {
          this.dhVisible = true;
          this.dhPrepare();
        }
      }

      dhPrepare() {
        if (this.dhLoaded || this.dhFinished || !this.dhConnected) return;
        this.dhLoaded = true;
        this.dataset.state = 'loading';
        this.dhImage.loading = 'eager';
        // Decode the real final still before starting; no thumbnail flash at the cut.
        const ready = this.dhImage.decode
          ? this.dhImage.decode()
          : new Promise((resolve, reject) => {
              if (this.dhImage.complete) {
                this.dhImage.naturalWidth ? resolve() : reject();
              } else {
                this.dhImage.addEventListener('load', resolve, { once: true, signal: this.dhAbort.signal });
                this.dhImage.addEventListener('error', reject, { once: true, signal: this.dhAbort.signal });
              }
            });
        ready.then(() => {
          if (!this.dhConnected || this.dhFinished) return;
          this.dhImageReady = true;
          this.dhTryPlay();
        }).catch(() => this.dhFinish());
        this.dhVideo.preload = 'auto';
        this.dhVideo.src = this.dhVideo.dataset.src;
        this.dhVideo.load();
        // A blocked network must not leave an endless black rectangle.
        this.dhLoadTimer = setTimeout(() => this.dhFinish(), 15000);
      }

      dhBuffered() {
        const video = this.dhVideo;
        if (!Number.isFinite(video.duration) || video.readyState < 3) return false;
        const goal = Math.min(this.dhTarget + 0.3, video.duration - 0.05);
        for (let i = 0; i < video.buffered.length; i += 1) {
          if (video.buffered.start(i) <= 0.05 && video.buffered.end(i) >= goal) return true;
        }
        return false;
      }

      async dhTryPlay() {
        if (!this.dhConnected || this.dhFinished || this.dhBusy ||
            !this.dhVisible || document.hidden || !this.dhImageReady) return;
        if (!this.dhStarted && !this.dhBuffered()) return;
        if (!this.dhVideo.paused) return;
        this.dhBusy = true;
        try {
          await this.dhVideo.play();
          if (!this.dhConnected || this.dhFinished) {
            this.dhVideo.pause();
            return;
          }
          this.dhStarted = true;
          this.dataset.state = 'playing';
          clearTimeout(this.dhLoadTimer);
          this.dhLastProgress = performance.now();
          if (!this.dhVisible || document.hidden) this.dhVideo.pause();
          this.dhTick();
        } catch (_) {
          // iOS Low Power Mode / autoplay restrictions: show the approved still.
          this.dhFinish();
        } finally {
          this.dhBusy = false;
        }
      }

      dhCheckFrame() {
        if (this.dhFinished || !this.dhStarted) return;
        const time = this.dhVideo.currentTime;
        if (time >= this.dhTarget) {
          this.dhFinish();
          return;
        }
        if (time !== this.dhLastTime) {
          this.dhLastTime = time;
          this.dhLastProgress = performance.now();
        }
      }

      dhTick() {
        cancelAnimationFrame(this.dhRaf);
        if (!this.dhConnected || this.dhFinished || !this.dhVisible || document.hidden) return;
        this.dhCheckFrame();
        if (this.dhFinished) return;
        if (performance.now() - this.dhLastProgress > 5000) {
          this.dhFinish();
          return;
        }
        this.dhRaf = requestAnimationFrame(() => this.dhTick());
      }

      dhVisibility() {
        if (this.dhFinished) return;
        if (!this.dhVisible || document.hidden) {
          this.dhVideo.pause();
          cancelAnimationFrame(this.dhRaf);
        } else {
          this.dhPrepare();
          this.dhTryPlay();
        }
      }

      dhFinish() {
        this.dhFinished = true;
        this.dataset.state = 'settled';
        if (this.dhVideo) this.dhVideo.pause();
        if (this.dhImage) this.dhImage.loading = 'eager';
        clearTimeout(this.dhLoadTimer);
        cancelAnimationFrame(this.dhRaf);
        this.dhPreloadObserver?.disconnect();
        this.dhPlayObserver?.disconnect();
      }

      disconnectedCallback() {
        this.dhConnected = false;
        this.dhAbort?.abort();
        this.dhVideo?.pause();
        clearTimeout(this.dhLoadTimer);
        cancelAnimationFrame(this.dhRaf);
        this.dhPreloadObserver?.disconnect();
        this.dhPlayObserver?.disconnect();
      }
    }
    customElements.define('dh-apex-reveal', DHApexReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.dh-calc:not([data-init])');
    sections.forEach(initCalc);

    function initCalc(root) {
      root.setAttribute('data-init', '1');

      const SIN20 = Math.sin(20 * Math.PI / 180);

      const basicHeight = root.querySelector('[data-input="basic-height"]');
      const advHeight   = root.querySelector('[data-input="adv-height"]');
      const advElbow    = root.querySelector('[data-input="adv-elbow"]');
      const advEye      = root.querySelector('[data-input="adv-eye"]');

      const tabs = root.querySelectorAll('.dh-calc__tab');
      const pill = root.querySelector('.dh-calc__tab-pill');
      const panels = root.querySelectorAll('[data-panel]');

      let mode = 'basic';

      function movePill(activeTab) {
        const tabsRect = activeTab.parentElement.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();
        pill.style.setProperty('--pill-w', tabRect.width + 'px');
        pill.style.setProperty('--pill-x', (tabRect.left - tabsRect.left - 6) + 'px');
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          mode = tab.dataset.mode;
          panels.forEach(p => {
            const active = p.dataset.panel === mode;
            p.hidden = !active;
            p.classList.toggle('is-active', active);
          });
          movePill(tab);
          compute();
        });
      });

      const firstActive = root.querySelector('.dh-calc__tab.is-active');
      if (firstActive) {
        requestAnimationFrame(() => movePill(firstActive));
        window.addEventListener('resize', () => {
          const cur = root.querySelector('.dh-calc__tab.is-active');
          if (cur) movePill(cur);
        });
      }

      [basicHeight, advHeight, advElbow, advEye].forEach(el => {
        if (el) el.addEventListener('change', compute);
      });

      function fmt(n, unit) {
        const rounded = Math.round(n * 10) / 10;
        const str = (rounded % 1 === 0) ? rounded.toFixed(0) : rounded.toFixed(1);
        return str + unit;
      }

      function pulse(el) {
        if (!el) return;
        el.classList.remove('is-updating');
        void el.offsetWidth;
        el.classList.add('is-updating');
      }

      function setOut(key, value) {
        root.querySelectorAll('[data-out="' + key + '"]').forEach(el => { el.textContent = value; });
        const big = root.querySelector('[data-out="' + key + '-big"]');
        if (big) {
          const match = value.match(/^([\d.]+)(\D+)$/);
          if (match) big.innerHTML = match[1] + '<small>' + match[2] + '</small>';
          else big.textContent = value;
          pulse(big);
        }
      }

      function heightLabel(inches) {
        const ft = Math.floor(inches / 12);
        const rem = inches % 12;
        return ft + "'" + rem + '"';
      }

      function bucketFor(inches) {
        if (inches < 66) return 'short';
        if (inches > 72) return 'tall';
        return 'average';
      }

      const recChip  = root.querySelector('[data-rec-chip]');
      const recCount = root.querySelector('[data-rec-count]');
      const recCards = root.querySelectorAll('[data-rec-bucket]');

      function updateRecs(heightInches) {
        if (!recCards.length) return;
        const bucket = bucketFor(heightInches);
        const label = heightLabel(heightInches);

        if (recChip) recChip.textContent = 'Matched to ' + label + ' · ' + bucket + ' build';

        let matches = 0;
        recCards.forEach((card) => {
          const cardBucket = card.dataset.recBucket;
          const isMatch = (cardBucket === bucket) || (cardBucket === 'all');
          card.dataset.dimmed = isMatch ? 'false' : 'true';
          if (isMatch) matches++;
          const tag = card.querySelector('[data-rec-tag]');
          if (tag) tag.textContent = 'Best for ' + cardBucket;
        });

        if (recCount) recCount.textContent = matches > 0 ? matches : recCards.length;
      }

      function compute() {
        let h, a, d;
        if (mode === 'basic') {
          h = parseFloat(basicHeight.value);
          const d3 = (43.7 * h / 70) - (10.5 * h / 70) * SIN20;
          const d2 = h - 4.5;
          setOut('d1', '28″');
          setOut('d2', fmt(d2, '″'));
          setOut('d3', fmt(d3, '″'));
          setOut('d4', '15°');
          setOut('d5', '17°');
        } else {
          h = parseFloat(advHeight.value);
          a = parseFloat(advElbow.value);
          d = parseFloat(advEye.value);
          const d3 = a - d * SIN20;
          const d2 = h - 4.5;
          setOut('d1', '28″');
          setOut('d2', fmt(d2, '″'));
          setOut('d3', fmt(d3, '″'));
          setOut('d4', '15°');
          setOut('d5', '17°');
        }
        updateRecs(h);
      }

      compute();

      const reveals = root.querySelectorAll('[data-reveal]');
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const idx = Array.from(reveals).indexOf(entry.target);
              entry.target.style.transitionDelay = (idx * 80) + 'ms';
              entry.target.classList.add('is-revealed');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        reveals.forEach(el => io.observe(el));
      } else {
        reveals.forEach(el => el.classList.add('is-revealed'));
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deskhaus-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const HEAD = .62; // the line's leading edge sits this far down the viewport
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const wide = matchMedia('(min-width: 900px)');
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const clamp01 = v => clamp(v, 0, 1);
  const instances = new WeakMap();

  // Headings only ever break between words. A word too long for its card ("manufacturing" in
  // a narrow panel, or a theme's bigger heading size) shrinks that heading just enough to fit.
  // Until this runs, CSS lets a word break so nothing spills out of its card.
  const FIT = '.dh-title > span, .dh-card h3, .dh-seg--info h4, .dh-seg--call h4';
  function fitHeadings(scope) {
    scope.querySelectorAll(FIT).forEach(h => {
      h.style.fontSize = '';
      if (!h.clientWidth) return; // hidden, like a closed phone story: fitted when it opens
      for (let i = 0; i < 6 && h.scrollWidth > h.clientWidth + 1; i++) {
        const size = parseFloat(getComputedStyle(h).fontSize);
        h.style.fontSize = `${Math.floor(size * h.clientWidth / h.scrollWidth * 10) / 10}px`;
      }
    });
  }

  function init(root) {
    if (instances.has(root)) return;
    const ac = new AbortController();
    const on = (target, type, fn, opts = {}) => target.addEventListener(type, fn, { ...opts, signal: ac.signal });

    /* ── The line: fills down the spine and through each joint ── */
    const list = root.querySelector('.dh-path');
    const spine = root.querySelector('.dh-spine');
    const items = [...list.querySelectorAll('.dh-item')];
    let geo = null, target = 0, current = 0, raf = 0;

    /* ── Heading photo under the site header ── */
    // When this section opens the page, it tucks up under the site header and the header's
    // full-width bar goes see-through while it sits over the photo.
    const hero = root.querySelector('.dh-hero');
    const under = { head: null, paint: [], clear: false, end: 0, saved: null };
    function findHeader() {
      if (!hero || !root.classList.contains('dh-story--under')) return null;
      const wrap = root.closest('.shopify-section') || root;
      for (let p = wrap.previousElementSibling; p; p = p.previousElementSibling) {
        if (p.offsetHeight) return null; // something else sits above this section
      }
      const head = document.querySelector('header')?.closest('.shopify-section, .section-header');
      return head && !head.contains(root) ? head : null;
    }
    function clearHeader(on) {
      if (!under.head || on === under.clear) return;
      under.clear = on;
      under.paint.forEach(el => el.classList.toggle('dh-see-through', on));
    }
    function setUnder() {
      clearHeader(false);
      if (under.saved) { Object.assign(under.head.style, under.saved); under.saved = null; }
      root.classList.remove('is-under');
      const head = under.head = findHeader();
      if (!head) return;
      // Tuck up by the whole gap from the header's top (below any announcement bar) to this
      // section, so the theme's own spacing around the header is covered too
      let top = 0;
      for (let p = head.previousElementSibling; p; p = p.previousElementSibling) {
        const pos = getComputedStyle(p).position;
        if (p.offsetHeight && pos !== 'fixed' && pos !== 'absolute') { top = p.getBoundingClientRect().bottom + scrollY; break; }
      }
      const gap = root.getBoundingClientRect().top + scrollY - top;
      root.style.setProperty('--under', `${Math.max(0, Math.round(gap))}px`);
      root.classList.add('is-under');
      under.paint = [head, ...head.querySelectorAll('*')].filter(el => {
        if (el.offsetWidth < innerWidth * .9) return false; // the floating nav keeps its own look
        const cs = getComputedStyle(el);
        return cs.backgroundColor !== 'rgba(0, 0, 0, 0)' || cs.backgroundImage !== 'none'
          || parseFloat(cs.borderBottomWidth) > 0 || cs.boxShadow !== 'none';
      });
      // The header has to sit above the photo
      if (getComputedStyle(head).position === 'static') {
        under.saved = { position: head.style.position, zIndex: head.style.zIndex };
        Object.assign(head.style, { position: 'relative', zIndex: '3' });
      }
    }

    // Geometry only changes on resize; scrolling never reads layout
    function layout() {
      const cs = getComputedStyle(root);
      geo = {
        top: list.getBoundingClientRect().top + scrollY,
        spineTop: spine.offsetTop,
        spineH: spine.offsetHeight,
        gap: parseFloat(getComputedStyle(list).rowGap) || 0,
        over: parseFloat(cs.getPropertyValue('--over')) || 0,
        tops: items.map(li => li.offsetTop),
        heights: items.map(li => li.offsetHeight),
        nums: items.map(li => li.querySelector('.dh-num')),
        vh: innerHeight,
        tagY: parseFloat(cs.getPropertyValue('--tag-y')) || 0,
      };
      if (under.head) under.end = hero.getBoundingClientRect().bottom + scrollY - under.head.offsetHeight;
    }

    // Numbers sink toward their cards as the page scrolls down. The rise stays
    // under the tuck set in CSS, so each foot never leaves its card.
    const NUM_SPEED = .08, NUM_UP = 24, NUM_DOWN = 30;
    function floatNumbers(head) {
      if (reduce.matches) return;
      const mid = head - geo.vh * (HEAD - .5); // screen centre, in list coordinates
      geo.nums.forEach((n, i) => {
        if (!n) return;
        const off = clamp((mid - (geo.tops[i] + geo.heights[i] / 2)) * NUM_SPEED, -NUM_UP, NUM_DOWN);
        n.style.transform = `translate3d(0, ${off.toFixed(1)}px, 0)`;
      });
    }
    // Only write what changed: each card-level variable restyles the whole card
    const joints = [];
    function render(head) {
      const { gap, over } = geo;
      spine.style.setProperty('--fill', clamp01((head - geo.spineTop) / geo.spineH).toFixed(4));
      items.forEach((li, i) => {
        const top = geo.tops[i];
        if (i > 0) {
          const j = clamp01((head - (top - gap - over)) / (gap + over * 2)).toFixed(3);
          if (joints[i] !== j) { joints[i] = j; li.style.setProperty('--joint', j); }
        }
        li.classList.toggle('is-lit', head >= top + geo.tagY);
      });
      floatNumbers(head);
    }

    /* ── Story callouts: pick a part and the panel's photo zooms to it ── */
    root.querySelectorAll('[data-dh-call]').forEach(panel => {
      const ui = panel.querySelector('.dh-call'), view = panel.querySelector('.dh-call__view');
      if (!ui || !view) return;
      const box = view.querySelector('.dh-call__box');
      const shots = [...box.children];
      const pills = [...ui.querySelectorAll('.dh-call__pill')];
      const text = ui.querySelector('.dh-call__text'), words = [...text.querySelectorAll('[data-part]')];
      const place = panel.querySelector('.dh-call__place');
      const [close, prev, next] = ['close', 'prev', 'next'].map(a => ui.querySelector(`[data-act="${a}"]`));
      let open = -1;

      const show = i => { const k = i === -1 ? 0 : +pills[i].dataset.shot || 0; shots.forEach((el, j) => el.classList.toggle('is-on', j === k)); };
      // Zoom so the part lands in the middle of the photo's side; where the photo is its own
      // frame (phones) it never shows past its edges
      function aim() {
        if (open === -1) { box.style.transform = ''; return; }
        const d = pills[open].dataset, sc = parseFloat(d.zoom) || 2;
        const W = view.clientWidth, H = view.clientHeight;
        const bx = box.offsetLeft, by = box.offsetTop, bw = box.offsetWidth, bh = box.offsetHeight;
        let tx = W / 2 - bx - (parseFloat(d.atX) / 100) * bw * sc;
        let ty = H / 2 - by - (parseFloat(d.atY) / 100) * bh * sc;
        if (bw >= W - 1) {
          tx = Math.min(-bx, Math.max(W - bx - bw * sc, tx));
          ty = Math.min(-by, Math.max(H - by - bh * sc, ty));
        }
        box.style.transform = `translate3d(${tx.toFixed(1)}px, ${ty.toFixed(1)}px, 0) scale(${sc})`;
      }
      function where(name) {
        const old = place && place.firstElementChild;
        if (old) { old.classList.add('is-off'); setTimeout(() => old.remove(), 500); }
        if (!place || !name) return;
        const el = document.createElement('div');
        el.className = 'is-off';
        el.append(document.createElement('small'), document.createElement('b'));
        el.firstChild.textContent = place.dataset.lead;
        el.lastChild.textContent = name;
        place.append(el);
        requestAnimationFrame(() => requestAnimationFrame(() => el.classList.remove('is-off')));
      }
      function fill(i) {
        words.forEach((w, j) => { w.hidden = j !== i; });
        // An arrow that runs out of parts can't keep focus: hand it to the other one
        const was = document.activeElement;
        prev.disabled = i === 0;
        next.disabled = i === pills.length - 1;
        if (was && was.disabled) moveFocus(was === prev ? next : prev);
      }
      // The card grows out of the pill that was pressed: a clip from its shape to the card's.
      // A background tab can hold an animation's end forever, so never wait on it alone.
      function grow(from, back) {
        if (reduce.matches || !text.animate) return Promise.resolve();
        const tb = text.getBoundingClientRect(), r = from.getBoundingClientRect();
        const pill = `inset(${r.top - tb.top}px ${tb.right - r.right}px ${tb.bottom - r.bottom}px ${r.left - tb.left}px round 26px)`;
        const frames = [{ clipPath: pill }, { clipPath: 'inset(0px 0px 0px 0px round 22px)' }];
        const ms = back ? 380 : 560;
        const a = text.animate(back ? frames.reverse() : frames, { duration: ms, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' });
        return Promise.race([a.finished, new Promise(done => setTimeout(done, ms + 120))]).then(() => a.cancel());
      }
      function openPart(i) {
        if (open === -1) {
          fill(i);
          ui.classList.add('is-open');
          pills.forEach((p, j) => p.classList.toggle('is-from', j === i));
          grow(pills[i]);
          moveFocus(close);
        } else if (i !== open) {
          text.classList.add('is-swap');
          setTimeout(() => { fill(i); text.classList.remove('is-swap'); }, reduce.matches ? 0 : 200);
        }
        pills.forEach((p, j) => p.setAttribute('aria-expanded', String(j === i)));
        open = i;
        show(i);
        aim();
        where(pills[i].dataset.place);
      }
      function shut() {
        if (open === -1) return;
        const i = open;
        open = -1;
        pills.forEach(p => p.setAttribute('aria-expanded', 'false'));
        show(-1);
        aim();
        where('');
        grow(pills[i], true).then(() => {
          if (open !== -1) return; // reopened meanwhile
          ui.classList.remove('is-open');
          pills.forEach(p => p.classList.remove('is-from'));
          moveFocus(pills[i]);
        });
      }
      // When its story closes, the panel goes back to its pills at once
      panel.dhCallReset = () => {
        open = -1;
        ui.classList.remove('is-open');
        pills.forEach(p => { p.classList.remove('is-from'); p.setAttribute('aria-expanded', 'false'); });
        show(-1);
        box.style.transform = '';
        if (place) place.textContent = '';
      };
      show(-1);
      pills.forEach((p, i) => on(p, 'click', () => openPart(i)));
      on(close, 'click', shut);
      on(prev, 'click', () => { if (open > 0) openPart(open - 1); });
      on(next, 'click', () => { if (open > -1 && open < pills.length - 1) openPart(open + 1); });
      // Esc closes an open part first (before it would close the whole story), from anywhere:
      // Safari doesn't focus a button when it's clicked
      on(window, 'keydown', e => { if (e.key === 'Escape' && open !== -1) { e.stopPropagation(); shut(); } }, { capture: true });
      on(window, 'resize', aim);
    });

    /* ── Slide-out stories ── */
    const rows = [...root.querySelectorAll('[data-x]')].map(el => ({
      el,
      dir: el.dataset.x === 'right' ? 1 : -1,
      stage: el.querySelector('.dh-stage'),
      slide: el.querySelector('.dh-slide'),
      keep: el.querySelector('.dh-card .dh-text'),
      band: el.querySelector('.dh-band'),
      open: el.querySelector('[data-open]'),
      exit: el.querySelector('[data-close]'),
      floats: [...el.querySelectorAll('.dh-float')].map(f => ({
        el: f,
        speed: parseFloat(f.dataset.speed) || 0,
        // never drift past the near edge of its own photo panel
        room: Math.max(0, (parseFloat(f.dataset.base) || 0) - (parseFloat(f.dataset.lo) || 0)),
      })),
      hash: '#' + el.id,
      travel: 0, timer: 0,
    }));
    const others = row => [root.querySelector('.dh-inner > header'), root.querySelector('.dh-signcard'),
      root.querySelector('.dh-close'), ...items.filter(li => li !== row.el)].filter(Boolean);
    let active = null, sTarget = 0, sCurrent = 0, lockY = null, settling = 0;
    const driving = () => !!active && wide.matches;

    function measure(row) {
      const segs = [...row.band.querySelectorAll('.dh-seg')];
      if (!segs.length) { row.travel = 0; return; }
      // Panels sit edge to edge from the card. Whole-photo desk tiles take their photo's shape
      // at the current card height; floating photos keep their place over their own panel.
      const side = row.dir === 1 ? 'right' : 'left';
      let pos = 0, last = 0;
      [...row.band.children].forEach(el => {
        if (el.classList.contains('dh-float')) {
          const off = (parseFloat(el.dataset.base) || 0) - (parseFloat(el.dataset.lo) || 0);
          el.style[side] = `${last + off}px`;
          return;
        }
        if (!el.classList.contains('dh-seg')) return;
        el.dataset.w ||= parseFloat(el.style.width) || el.offsetWidth;
        const ar = parseFloat(el.dataset.ar);
        const w = ar && wide.matches ? Math.round(el.offsetHeight * ar) : +el.dataset.w;
        el.style[side] = `${pos}px`;
        el.style.width = `${w}px`;
        last = pos;
        pos += w + 6;
      });
      const bandW = Math.max(0, pos - 6);
      row.band.style.width = `${bandW}px`;
      const cs = getComputedStyle(row.el);
      const seam = parseFloat(cs.getPropertyValue('--seam')) || 0;
      const hang = parseFloat(cs.getPropertyValue('--hang')) || 0;
      // From the screen edge the text half hangs off, out to the far end of the band
      const reach = -hang + row.keep.offsetWidth + seam + bandW;
      row.travel = Math.max(0, reach - (document.documentElement.clientWidth - 48));
      sTarget = clamp(sTarget, 0, row.travel);
    }

    function renderRow(row, x) {
      row.slide.style.setProperty('--dh-x', `${x.toFixed(1)}px`);
      if (reduce.matches) return;
      row.floats.forEach(f => {
        const d = Math.min(x * f.speed, f.room);
        f.el.style.transform = `translate3d(${(d * row.dir).toFixed(1)}px, ${(x * -.012).toFixed(1)}px, 0)`;
      });
    }

    // One gentle settle loop for both the line and the open band
    function tick() {
      const k = reduce.matches ? 1 : .14;
      current += (target - current) * k;
      sCurrent += (sTarget - sCurrent) * k;
      if (Math.abs(target - current) < .5) current = target;
      if (Math.abs(sTarget - sCurrent) < .5) sCurrent = sTarget;
      render(current);
      if (driving()) {
        renderRow(active, sCurrent);
        // The clock for closing starts once the band has settled on either end
        const atAnEnd = sTarget >= active.travel - .5 || sTarget <= .5;
        endAt = sCurrent === sTarget && atAnEnd ? endAt || performance.now() : 0;
      }
      raf = current === target && sCurrent === sTarget ? 0 : requestAnimationFrame(tick);
    }
    const kick = () => { if (!raf) raf = requestAnimationFrame(tick); };
    const nudge = d => { sTarget = clamp(sTarget + d, 0, active.travel); kick(); };

    let pin = null;
    function onScroll() {
      if (!geo) return;
      if (pin) {
        if (performance.now() < pin.until && Math.abs(scrollY - pin.y) > 1) { scrollTo(0, pin.y); return; }
        if (performance.now() >= pin.until) pin = null;
      }
      clearHeader(scrollY < under.end);
      // While a story is open the page holds still (this also catches scrollbar drags)
      if (driving() && lockY !== null && !settling && Math.abs(scrollY - lockY) > 1) {
        scrollTo(0, lockY);
        return;
      }
      target = scrollY + innerHeight * HEAD - geo.top;
      kick();
    }

    // Input that would scroll the page moves the band instead. Scrolling down always moves on
    // through the story (panels that open out to the left slide in from the left), at least twice
    // as far as the page would have gone and faster on a long band, so any story takes about a
    // screen's worth of scrolling; a sideways swipe moves the band the way the fingers go.
    // Scrolling on past either end of the band closes the story, and the next scroll moves the
    // page; the rest of the closing gesture is held back so it can't carry the page on as well.
    const QUIET = 250; // a pause this long starts a new gesture
    const pace = () => Math.max(2, active.travel / innerHeight);
    let lastWheel = 0;
    const atEnd = d => (d > 0 ? sTarget >= active.travel - .5 : d < 0 && sTarget <= .5);
    // At an end, scrolling on closes the story, but only once the band has settled there for
    // REST, so a scroll that has only just arrived can't carry straight on out. After that a new
    // scroll closes it, and so does a mouse wheel kept rolling or a trackpad still gliding once
    // the band has rested for HOLD.
    const REST = 800, HOLD = 1200;
    let endAt = 0; // when the band settled on an end; the settle loop sets it
    const rested = now => !!endAt && now - endAt >= REST;
    function pushedOn(fresh, now, since = endAt) {
      return !!since && now - since >= REST && (fresh || now - since >= HOLD);
    }
    function leave(via) {
      const row = active;
      setOpen(row, false);
      moveFocus(row.open);
      if (via === 'key') return;
      const hush = new AbortController();
      const stop = () => hush.abort();
      const opts = { capture: true, passive: false, signal: hush.signal };
      if (via === 'touch') {
        // The rest of this swipe, until the finger lifts
        window.addEventListener('touchmove', e => { if (e.cancelable) e.preventDefault(); }, opts);
        window.addEventListener('touchend', stop, opts);
      } else {
        // The rest of this wheel gesture, until it pauses. Capture runs ahead of the theme's
        // wheel smoother, which stands aside for a wheel that's already been taken.
        window.addEventListener('wheel', e => {
          const now = performance.now();
          if (now - lastWheel > QUIET) { stop(); return; }
          lastWheel = now;
          e.preventDefault();
        }, opts);
      }
      setTimeout(stop, 1500);
    }
    function onWheel(e) {
      if (!driving()) return;
      e.preventDefault();
      const now = performance.now(), fresh = now - lastWheel > QUIET;
      lastWheel = now;
      const unit = e.deltaMode === 1 ? 32 : e.deltaMode === 2 ? innerWidth : 1;
      const dx = e.deltaX * -active.dir; // swiping toward where the band comes from moves forward
      const dy = e.deltaY;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { nudge(dx * unit); return; }
      if (atEnd(dy)) { if (pushedOn(fresh, now)) leave('wheel'); return; }
      nudge(dy * unit * pace());
    }
    let touch = null;
    function onTouchStart(e) {
      if (!driving()) return;
      const t = e.touches[0];
      touch = { x: t.clientX, y: t.clientY, x0: t.clientX, y0: t.clientY, fresh: true };
    }
    function onTouchMove(e) {
      if (!driving() || !touch) return;
      e.preventDefault();
      const t = e.touches[0];
      if (touch.fresh) {
        // A swipe's first clear move decides: up or down on past an end closes the story
        const ox = (touch.x0 - t.clientX) * -active.dir, oy = touch.y0 - t.clientY;
        if (Math.max(Math.abs(ox), Math.abs(oy)) < 10) return;
        touch.fresh = false;
        if (Math.abs(oy) > Math.abs(ox) && atEnd(oy)) {
          // Too soon after reaching the end, this swipe does nothing; the next one closes it
          const now = performance.now();
          touch = null;
          if (rested(now)) leave('touch');
          return;
        }
      }
      const dx = (touch.x - t.clientX) * -active.dir, dy = touch.y - t.clientY;
      touch.x = t.clientX; touch.y = t.clientY;
      nudge(Math.abs(dx) > Math.abs(dy) ? dx : dy * pace());
    }

    // Phones (and narrow windows): the story is its own screen and scrolls by itself. Scrolling
    // on past its top or bottom closes it the same way, and the next scroll moves the page.
    const sheetEnd = (row, d) => {
      const s = row.stage;
      return d > 0 ? s.scrollTop + s.clientHeight >= s.scrollHeight - 1 : d < 0 && s.scrollTop <= 0;
    };
    // When the story's own screen reached the end it's being pushed past (0 if it isn't there yet).
    // A story that fits on one screen counts from when it opened.
    const sheetSince = (row, d) => {
      const ends = row.endAt || {};
      if (d < 0) return ends.top || 0;
      const fits = row.stage.scrollHeight <= row.stage.clientHeight + 1;
      return ends.bottom || (fits ? ends.top : 0) || 0;
    };
    // Capture, so it runs ahead of the theme's wheel smoother
    function onSheetWheel(e) {
      if (!active || wide.matches || !active.stage.contains(e.target)) return;
      const now = performance.now(), fresh = now - lastWheel > QUIET;
      lastWheel = now;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) || !sheetEnd(active, e.deltaY)) return;
      e.preventDefault();
      if (pushedOn(fresh, now, sheetSince(active, e.deltaY))) leave('wheel');
    }
    let sheetTouch = null;
    function onSheetTouchStart(e) {
      sheetTouch = null;
      if (!active || wide.matches || !active.stage.contains(e.target)) return;
      const t = e.touches[0];
      const now = performance.now(), downAt = sheetSince(active, 1), upAt = sheetSince(active, -1);
      sheetTouch = { x: t.clientX, y: t.clientY,
        down: sheetEnd(active, 1) && !!downAt && now - downAt >= REST,
        up: sheetEnd(active, -1) && !!upAt && now - upAt >= REST };
    }
    function onSheetTouchMove(e) {
      if (!sheetTouch || !active || wide.matches) return;
      const t = e.touches[0];
      const dx = sheetTouch.x - t.clientX, dy = sheetTouch.y - t.clientY;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 10) return;
      // A swipe's first clear move decides
      const s = sheetTouch;
      sheetTouch = null;
      if (Math.abs(dy) > Math.abs(dx) && (dy > 0 ? s.down : s.up)) leave('touch');
    }
    function onKey(e) {
      if (!active) return;
      if (e.key === 'Escape') { const r = active; setOpen(r, false); r.open.focus(); return; }
      // The page holds still behind an open story, so Tab stays inside it ("Our story" and Esc lead out)
      if (e.key === 'Tab') {
        const f = [...active.el.querySelectorAll('a[href], button:not([disabled])')].filter(el => !el.closest('[inert]') && el.getClientRects().length);
        const i = f.indexOf(document.activeElement);
        if (f.length && (e.shiftKey ? i <= 0 : i === -1 || i === f.length - 1)) { e.preventDefault(); f[e.shiftKey ? f.length - 1 : 0].focus(); }
        return;
      }
      if (!driving() || e.target.closest('input, textarea, select')) return;
      const page = innerWidth * .8;
      const fwd = active.dir < 0 ? 'ArrowRight' : 'ArrowLeft';
      const back = active.dir < 0 ? 'ArrowLeft' : 'ArrowRight';
      const step = { [fwd]: 120, [back]: -120, ArrowDown: 120, ArrowUp: -120,
        PageDown: page, PageUp: -page, ' ': e.shiftKey ? -page : page }[e.key];
      if (e.key === 'Home') { e.preventDefault(); sTarget = 0; kick(); return; }
      if (e.key === 'End') { e.preventDefault(); sTarget = active.travel; kick(); return; }
      if (step === undefined || (e.key === ' ' && e.target.closest('button, a'))) return;
      e.preventDefault();
      // Paging on past either end closes the story too; the next press moves the page
      if (!e.repeat && !/^Arrow(Left|Right)$/.test(e.key) && atEnd(step)) { leave('key'); return; }
      nudge(step);
    }

    let driveAc = null;
    function drive(go) {
      go = !!go;
      if (go === !!driveAc) return;
      // While the band takes the wheel, the theme's wheel smoother (dh-smooth-scroll.js) stands aside
      document.documentElement.toggleAttribute('data-lenis-prevent', go);
      if (!go) { driveAc.abort(); driveAc = null; return; }
      driveAc = new AbortController();
      const o = (type, fn, passive) => window.addEventListener(type, fn, { passive, signal: driveAc.signal });
      o('wheel', onWheel, false);
      o('touchstart', onTouchStart, true);
      o('touchmove', onTouchMove, false);
      o('touchend', () => { touch = null; }, true);
    }

    // Hold the page still behind a phone story. Only ever undo our own lock, so a theme
    // drawer's lock is left alone.
    let locked = null;
    function lockPage(on) {
      const html = document.documentElement;
      if (on && locked === null) { locked = html.style.overflow; html.style.overflow = 'hidden'; }
      else if (!on && locked !== null) { html.style.overflow = locked; locked = null; }
    }

    // Phones: the story is its own screen. Hold the page still behind it and keep the
    // card's spot so nothing below shifts; on close the screen slides back out.
    function sheet(row, open) {
      clearTimeout(row.leave);
      if (open) {
        row.el.classList.remove('is-leaving');
        row.el.style.minHeight = `${row.el.offsetHeight}px`;
        lockPage(true);
        row.stage.scrollTop = 0;
        row.endAt = { top: performance.now(), bottom: 0 }; // it opens at its top
        return;
      }
      const done = () => {
        row.el.classList.remove('is-leaving');
        row.el.style.minHeight = '';
        if (!active) lockPage(false);
      };
      if (reduce.matches) { done(); return; }
      row.el.classList.add('is-leaving');
      row.leave = setTimeout(done, 400);
    }

    function setOpen(row, open, { push = true } = {}) {
      if (open === (active === row)) return;
      if (open && active) setOpen(active, false, { push: false });

      // The slide eases only while opening or closing; otherwise it follows input
      row.el.classList.add('is-animating');
      clearTimeout(row.timer);
      row.timer = setTimeout(() => row.el.classList.remove('is-animating'), 900);

      active = open ? row : null; // before sheet(): with reduced motion it unlocks the page at once, which needs nothing open
      if (!wide.matches) sheet(row, open);
      if (open) root.dataset.open = row.dir > 0 ? 'right' : 'left';
      else delete root.dataset.open;
      row.el.classList.toggle('is-open', open);
      // A phone story's screen only scrolls once .is-open applies, so sheet()'s reset can't take; start it at its top here
      if (open && !wide.matches) row.stage.scrollTop = 0;
      if (open) fitHeadings(row.el); // a phone story's panels only take up room once open
      others(row).forEach(el => { el.inert = open; });
      row.band.inert = !open;
      row.exit.inert = !open;
      row.open.setAttribute('aria-expanded', String(open));
      // The pinned back button is the one way out
      row.open.inert = open;
      sTarget = sCurrent = endAt = 0;

      if (open && wide.matches) {
        measure(row);
        renderRow(row, 0);
        // Center the row in the space under a sticky site header (leaving room for the desk
        // names above the panels), then hold the page there
        const r = row.stage.getBoundingClientRect();
        const head = document.querySelector('header')?.closest('.shopify-section, .section-header');
        const pinned = head && /sticky|fixed/.test(getComputedStyle(head).position) ? Math.max(0, head.getBoundingClientRect().bottom) : 0;
        const want = Math.max(pinned + 72, pinned + (innerHeight - pinned - r.height) / 2);
        lockY = scrollY + (r.top - want);
        clearTimeout(settling);
        settling = setTimeout(() => {
          settling = 0;
          if (active === row && Math.abs(scrollY - lockY) > 1) scrollTo(0, lockY); // finish a cut-short glide
        }, 700);
        scrollTo({ top: lockY, behavior: reduce.matches ? 'auto' : 'smooth' });
      } else if (!open) {
        row.el.querySelectorAll('[data-dh-call]').forEach(c => c.dhCallReset?.()); // a closed story starts fresh
        lockY = null;
        clearTimeout(settling); settling = 0;
        row.slide.style.removeProperty('--dh-x');
        row.floats.forEach(f => { f.el.style.transform = ''; });
      }

      if (push) {
        try {
          if (open) history.pushState({ dhStory: row.el.id }, '', row.hash);
          else if (history.state?.dhStory === row.el.id) {
            // Step back off the entry opening added, so Back afterwards leaves the page
            // instead of reopening the story
            holdY = scrollY;
            history.back();
          } else if (location.hash === row.hash) history.replaceState(null, '', location.pathname + location.search);
        } catch (_) { /* sandboxed preview: skip the link, keep the story working */ }
      }
      drive(driving());
      kick();
    }

    // Moving focus after a tap shouldn't draw the keyboard ring (Safari does)
    let viaKey = false;
    on(window, 'keydown', () => {
      viaKey = true;
      root.querySelectorAll('[data-quiet]').forEach(el => { delete el.dataset.quiet; });
    }, { capture: true });
    on(window, 'pointerdown', () => { viaKey = false; }, { capture: true });
    function moveFocus(el) {
      if (!viaKey) {
        el.dataset.quiet = '';
        el.addEventListener('blur', () => { delete el.dataset.quiet; }, { once: true });
      }
      el.focus({ preventScroll: true });
    }

    rows.forEach(row => {
      row.exit.inert = true;
      on(row.open, 'click', () => {
        setOpen(row, active !== row);
        if (active === row) moveFocus(row.exit);
      });
      on(row.exit, 'click', () => { setOpen(row, false); moveFocus(row.open); });
      // Keyboard focus on a panel's link slides the band until the link is on screen
      on(row.band, 'focusin', e => {
        if (active !== row || !driving()) return;
        const r = e.target.getBoundingClientRect(), vw = document.documentElement.clientWidth;
        const by = r.left < 48 ? 48 - r.left : r.right > vw - 48 ? vw - 48 - r.right : 0;
        if (by) { sTarget = clamp(sCurrent + by * row.dir, 0, row.travel); kick(); }
      });
      // Phones: note when the story's own screen reaches its top and its bottom, for the rest before closing
      on(row.stage, 'scroll', () => {
        if (wide.matches) return;
        const now = performance.now(), ends = row.endAt || (row.endAt = { top: 0, bottom: 0 });
        ends.top = sheetEnd(row, -1) ? ends.top || now : 0;
        ends.bottom = sheetEnd(row, 1) ? ends.bottom || now : 0;
      }, { passive: true });
    });
    let holdY = null;
    if (rows.length) {
      on(window, 'popstate', () => {
        if (holdY !== null) {
          // Browsers restore the scroll from before the story opened, each on its own
          // timing; pin the page where it is for a moment instead
          pin = { y: holdY, until: performance.now() + 400 };
          holdY = null;
          scrollTo(0, pin.y);
          return;
        }
        const want = rows.find(r => r.hash === location.hash);
        if (want) setOpen(want, true, { push: false });
        else if (active) { const r = active, had = r.el.contains(document.activeElement); setOpen(r, false, { push: false }); if (had) moveFocus(r.open); }
      });
      on(window, 'keydown', onKey);
      on(window, 'wheel', onSheetWheel, { passive: false, capture: true });
      on(window, 'touchstart', onSheetTouchStart, { passive: true });
      on(window, 'touchmove', onSheetTouchMove, { passive: true });
    }

    on(window, 'scroll', onScroll, { passive: true });
    let lastW = innerWidth;
    on(window, 'resize', () => {
      // iOS fires resize as the address bar grows and shrinks; only a width change moves the header
      if (innerWidth !== lastW) { lastW = innerWidth; setUnder(); fitHeadings(root); }
      layout();
      clearHeader(scrollY < under.end);
      if (driving()) { measure(active); kick(); }
      else if (active) lockY = null; // phone layout: the story is its own screen
      drive(driving());
      lockPage(!!active && !wide.matches);
    });
    const ro = new ResizeObserver(() => { layout(); onScroll(); });
    ro.observe(list);
    root.classList.add('dh-words');
    fitHeadings(root);
    setUnder();
    layout();
    onScroll();
    // The web font can land after this runs and change every word's width
    document.fonts?.ready.then(() => { if (!instances.has(root)) return; fitHeadings(root); layout(); onScroll(); });
    const deep = rows.find(r => r.hash === location.hash);
    if (deep) setOpen(deep, true, { push: false });

    instances.set(root, {
      // Theme editor: open the story a selected panel belongs to
      show(el) {
        const row = rows.find(r => r.el === el);
        if (row && active !== row) setOpen(row, true, { push: false });
      },
      destroy() {
        if (active) setOpen(active, false, { push: false });
        drive(false);
        lockPage(false);
        clearHeader(false);
        if (under.saved) Object.assign(under.head.style, under.saved);
        ac.abort();
        ro.disconnect();
        cancelAnimationFrame(raf);
      },
    });
  }

  const boot = scope => scope.querySelectorAll('[data-dh-story]').forEach(init);
  boot(document);

  // Shopify theme editor
  document.addEventListener('shopify:section:load', e => boot(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-dh-story]').forEach(r => { instances.get(r)?.destroy(); instances.delete(r); });
  });
  document.addEventListener('shopify:block:select', e => {
    const root = e.target.closest('[data-dh-story]');
    const row = e.target.closest('[data-x]');
    if (root && row) instances.get(root)?.show(row);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const stickyTriggerOffset = 500; // increase for later trigger
      const stickyStart = (this.headerBounds.bottom || 0) + stickyTriggerOffset;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > stickyStart) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > stickyStart) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= stickyStart) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-act-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const video = document.getElementById('scrollVideo');

  video.addEventListener('canplaythrough', function() {
    video.play().catch(() => console.log("Autoplay blocked"));

    // Load GSAP if not already loaded
    if (typeof gsap === 'undefined') {
      const gsapScript = document.createElement('script');
      gsapScript.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.14.0/gsap.min.js";
      document.head.appendChild(gsapScript);
      gsapScript.onload = loadScrollTrigger;
    } else {
      loadScrollTrigger();
    }

    function loadScrollTrigger() {
      if (typeof ScrollTrigger === 'undefined') {
        const triggerScript = document.createElement('script');
        triggerScript.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.14.0/ScrollTrigger.min.js";
        document.head.appendChild(triggerScript);
        triggerScript.onload = initScrollScrub;
      } else {
        initScrollScrub();
      }
    }

    function initScrollScrub() {
      gsap.registerPlugin(ScrollTrigger);

      const duration = video.duration;

      gsap.to(video, {
        currentTime: duration,
        ease: "none",
        scrollTrigger: {
          trigger: ".scroll-video-wrapper",
          start: "top top",
          end: "+=600vh",     // matches spacer height
          scrub: true,
          onUpdate: self => {
            // Optional: loop video during scroll
            if (video.currentTime >= video.duration) {
              video.currentTime = 0;
            }
          }
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wood-top-compare-pill"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Aggressive smooth-scroller detection. Walks common globals AND scans
    // window for any object with a scrollTo function that looks Lenis-shaped
    // (has .raf or .isSmooth or .options.duration).
    function getSmoothScroller() {
      var candidates = ['lenis', 'Lenis', '__lenis', '_lenis', 'lenisInstance', 'smoothScroll', 'scroller', 'dhLenis', 'scrollInstance'];
      for (var i = 0; i < candidates.length; i++) {
        var g = window[candidates[i]];
        if (!g) continue;
        if (typeof g.scrollTo === 'function') return { kind: 'lenis', instance: g, name: candidates[i] };
        if (g.instance && typeof g.instance.scrollTo === 'function') return { kind: 'lenis', instance: g.instance, name: candidates[i] + '.instance' };
      }
      // Last-ditch: scan window for a lenis-shaped object.
      try {
        for (var k in window) {
          if (!Object.prototype.hasOwnProperty.call(window, k)) continue;
          var v = window[k];
          if (!v || typeof v !== 'object') continue;
          if (typeof v.scrollTo === 'function' && (typeof v.raf === 'function' || 'isSmooth' in v || 'targetScroll' in v)) {
            return { kind: 'lenis', instance: v, name: k };
          }
        }
      } catch (e) {}
      if (window.locomotive && typeof window.locomotive.scrollTo === 'function') return { kind: 'locomotive', instance: window.locomotive, name: 'locomotive' };
      if (window.Scrollbar && typeof window.Scrollbar.get === 'function') {
        var sb = window.Scrollbar.get(document.scrollingElement) || window.Scrollbar.get(document.body);
        if (sb && typeof sb.scrollTo === 'function') return { kind: 'scrollbar', instance: sb, name: 'Scrollbar' };
      }
      return null;
    }

    function init(root) {
      if (!root || root.dataset.dhPillInit === '1') return;
      root.dataset.dhPillInit = '1';

      var pill = root.querySelector('.dh-pill');
      var label = root.querySelector('.dh-pill__label');
      var targetType = (root.dataset.targetSectionType || 'dim-vs-fle').trim();
      var targetSelector = (root.dataset.targetSelector || '').trim();
      var scrollOffset = parseInt(root.dataset.scrollOffset, 10);
      if (isNaN(scrollOffset)) scrollOffset = 80;
      var appearDelay = parseInt(root.dataset.appearDelay, 10);
      if (isNaN(appearDelay)) appearDelay = 3000;

      if (root.parentNode !== document.body) {
        document.body.appendChild(root);
      }

      function findTarget() {
        if (targetSelector) {
          try {
            var el = document.querySelector(targetSelector);
            if (el) return el;
          } catch (e) {}
        }
        var typeDash = targetType.replace(/_/g, '-').toLowerCase();
        var typeUnder = targetType.replace(/-/g, '_').toLowerCase();
        var wrappers = document.querySelectorAll('[id^="shopify-section-"]');
        for (var i = 0; i < wrappers.length; i++) {
          var id = (wrappers[i].id || '').toLowerCase();
          if (id.indexOf(typeDash) !== -1 || id.indexOf(typeUnder) !== -1) {
            return wrappers[i];
          }
        }
        var byClass = document.querySelector('.' + typeDash);
        if (byClass) return byClass;
        return null;
      }

      function findProductSection() {
        var wrappers = document.querySelectorAll('[id^="shopify-section-"]');
        for (var i = 0; i < wrappers.length; i++) {
          var id = (wrappers[i].id || '').toLowerCase();
          if (id.indexOf('main-product') !== -1 || id.indexOf('__main') !== -1) {
            return wrappers[i];
          }
        }
        return document.querySelector('main') || document.body;
      }

      function measurePill() {
        if (!label || !pill) return;
        var clone = pill.cloneNode(true);
        clone.style.cssText =
          'position:absolute;visibility:hidden;width:auto;left:-9999px;top:0;' +
          'transition:none;transform:none;';
        var lbl = clone.querySelector('.dh-pill__label');
        if (lbl) { lbl.style.position = 'static'; lbl.style.opacity = '1'; lbl.style.transform = 'none'; }
        document.body.appendChild(clone);
        var w = Math.ceil(clone.getBoundingClientRect().width) + 72;
        document.body.removeChild(clone);
        root.style.setProperty('--dh-pill-full-width', w + 'px');
      }
      measurePill();
      window.addEventListener('resize', measurePill, { passive: true });

      var appearReady = false;
      var productInView = false;
      var targetInView = false;
      var footerInView = false;

      function applyState() {
        var shouldShow = appearReady && productInView && !targetInView && !footerInView;
        root.classList.toggle('is-visible', shouldShow);
        root.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      // Delay before the pill is allowed to appear — user gets time to
      // look at the product before the pill animates in.
      setTimeout(function () { appearReady = true; applyState(); }, appearDelay);

      var productEl = findProductSection();
      var target = findTarget();

      if ('IntersectionObserver' in window && productEl) {
        var productObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            productInView = entry.isIntersecting;
            applyState();
          });
        }, { threshold: 0 });
        productObs.observe(productEl);
      } else {
        productInView = true;
        applyState();
      }

      if ('IntersectionObserver' in window && target) {
        var targetObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            targetInView = entry.isIntersecting;
            applyState();
          });
        }, { threshold: 0.2 });
        targetObs.observe(target);
      }

      var footerEl =
        document.querySelector('footer') ||
        document.querySelector('.footer') ||
        document.querySelector('[class*="footer"]') ||
        document.querySelector('[id*="footer" i]');
      if ('IntersectionObserver' in window && footerEl) {
        var footerObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            footerInView = entry.isIntersecting;
            applyState();
          });
        }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
        footerObs.observe(footerEl);
      }

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var nearBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 140);
            if (nearBottom && !footerInView) { footerInView = true; applyState(); }
            else if (!nearBottom && footerInView && !footerEl) { footerInView = false; applyState(); }
          });
        }
      }, { passive: true });

      // ==================================================================
      // LENIS-AWARE SCROLLER
      // The site runs Lenis smooth-scroll (detectable via `.lenis` class on
      // <html>). Lenis swallows every programmatic scroll method:
      //   * window.scrollTo()      — swallowed
      //   * element.scrollTo()     — swallowed
      //   * .scrollTop = y         — snapped back next frame
      // The only input Lenis respects is a real WheelEvent. Dispatching a
      // synthetic wheel with the full delta makes Lenis animate to the
      // target using its own easing — matches site scroll feel exactly.
      // This is the same approach used by the working Peak Pro hero button.
      // ==================================================================
      function scrollToY(y) {
        var scroller = document.scrollingElement || document.documentElement;
        var startY = scroller.scrollTop;
        var delta = y - startY;
        if (Math.abs(delta) < 2) return;

        var usesLenis = document.documentElement.classList.contains('lenis');

        if (usesLenis) {
          var evt = new WheelEvent('wheel', {
            deltaY: delta,
            deltaMode: 0,
            bubbles: true,
            cancelable: true
          });
          window.dispatchEvent(evt);
          return;
        }

        // No Lenis — native smooth scroll works fine.
        window.scrollTo({ top: y, behavior: 'smooth' });
      }

      if (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Blur to clear focus (fixes aria-hidden warning).
          try { pill.blur(); } catch (err) {}

          var t = findTarget();
          if (!t) {
            console.warn('[dh-pill] scroll target not found. type=' + targetType + ' selector=' + targetSelector);
            return;
          }
          target = t;
          if (!t.id) t.id = 'dh-pill-target-' + Date.now();

          var endY = t.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
          scrollToY(endY);
        });
      }

      window.__dhPillDebug = function () {
        var t = findTarget();
        var s = getSmoothScroller();
        console.log('[dh-pill] targetType:', targetType);
        console.log('[dh-pill] resolved target:', t);
        console.log('[dh-pill] product section:', productEl);
        console.log('[dh-pill] smooth scroller:', s);
        console.log('[dh-pill] appear delay (ms):', appearDelay, 'ready:', appearReady);
        return { target: t, smooth: s };
      };
    }

    function boot() {
      document.querySelectorAll('.dh-pill-wrap').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.dh-pill-wrap') : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wood-tops"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wood-tops')) {
    customElements.define('wood-tops', class WoodTops extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.wt__grid');
        if (!this.grid) return;
        this.items = [...this.grid.querySelectorAll('.wt__item')];
        this.speciesBtns = [...this.querySelectorAll('.wt__species-btn')];
        this.sizeBtns = [...this.querySelectorAll('.wt__chip')];
        this.sortSelect = this.querySelector('.wt__sort-select');
        this.status = this.querySelector('.wt__status');
        this.empty = this.querySelector('.wt__empty');
        this.moreWrap = this.querySelector('.wt__more-wrap');
        this.moreBtn = this.querySelector('.wt__more');
        this.dialog = this.querySelector('.wt__dialog');
        this.pageSize = parseInt(this.dataset.pageSize, 10) || 24;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.spring = 'linear(0, 0.034 1.5%, 0.13 3.2%, 0.464 8.3%, 0.723 13%, 0.896 18%, 0.994 23.5%, 1.04 29%, 1.05 34%, 1.04 40%, 1.016 50%, 1.002 60%, 0.998 72%, 1)';

        // Size and area for sorting, read from the size text (e.g. 30" x 72").
        this.items.forEach((item) => {
          const nums = (item.dataset.sizeText.match(/[\d.]+/g) || []).map(Number);
          item._area = nums.length >= 2 ? nums[0] * nums[1] : nums[0] || 0;
          item._price = parseInt(item.dataset.price, 10) || 0;
          item._order = parseInt(item.dataset.order, 10) || 0;
          item._stock = parseInt(item.dataset.stock, 10) || 0;
        });

        const sizesRow = this.querySelector('.wt__sizes');
        if (sizesRow) {
          const area = (b) => { const n = (b.dataset.sizeText || '').match(/[\d.]+/g) || []; return n.length >= 2 ? n[0] * n[1] : +n[0] || 0; };
          [...this.sizeBtns].filter((b) => b.dataset.size).sort((a, b) => area(a) - area(b)).forEach((b) => sizesRow.appendChild(b));
        }

        const params = new URLSearchParams(location.search);
        this.state = {
          species: params.get('species') || '',
          size: params.get('size') || '',
          sort: params.get('sort') || 'featured',
          shown: this.pageSize
        };
        if (this.sortSelect) this.sortSelect.value = this.state.sort;
        if (this.state.species && !this.speciesBtns.some((b) => b.dataset.species === this.state.species)) this.state.species = '';

        this.speciesBtns.forEach((b) => b.addEventListener('click', () => this.set({ species: b.dataset.species })));
        this.sizeBtns.forEach((b) => b.addEventListener('click', () => {
          if (b.getAttribute('aria-disabled') === 'true') return;
          this.set({ size: b.dataset.size });
        }));
        this.sortSelect?.addEventListener('change', () => this.set({ sort: this.sortSelect.value }));
        this.querySelector('.wt__clear')?.addEventListener('click', () => this.set({ species: '', size: '' }));
        this.moreBtn?.addEventListener('click', () => this.set({ shown: this.state.shown + this.pageSize }, { keepShown: true }));

        this.grid.addEventListener('click', (e) => {
          const open = e.target.closest('.wt__open');
          if (open) this.openDetail(open.closest('.wt__item'), open);
        });
        this.dialog?.querySelector('.wt__d-close').addEventListener('click', () => this.dialog.close());
        this.dialog?.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
        this.dialog?.addEventListener('close', () => { this.lastOpener?.focus(); });

        this.querySelector('.wt__filters').hidden = false;
        this.render(false);
      }

      set(change, opts = {}) {
        const resetShown = !opts.keepShown && ('species' in change || 'size' in change || 'sort' in change);
        Object.assign(this.state, change);
        if (resetShown) this.state.shown = this.pageSize;
        this.syncUrl();
        this.render(true);
      }

      syncUrl() {
        const params = new URLSearchParams(location.search);
        const put = (k, v, d) => { if (v && v !== d) params.set(k, v); else params.delete(k); };
        put('species', this.state.species, '');
        put('size', this.state.size, '');
        put('sort', this.state.sort, 'featured');
        const q = params.toString();
        history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + location.hash);
      }

      matches(item, species, size) {
        return (!species || item.dataset.species === species) && (!size || item.dataset.size === size);
      }

      render(animate) {
        const { species, size, sort } = this.state;

        // Counts: each species counts tops in the chosen size; each size counts tops of the chosen species.
        this.speciesBtns.forEach((b) => {
          const n = this.items.reduce((sum, i) => sum + (this.matches(i, b.dataset.species, size) ? i._stock : 0), 0);
          b.querySelector('.wt__count').textContent = n;
          b.setAttribute('aria-label', `${b.querySelector('.wt__species-name').textContent}, ${n} in stock`);
          b.setAttribute('aria-pressed', String(b.dataset.species === species));
        });
        this.sizeBtns.forEach((b) => {
          const n = this.items.filter((i) => this.matches(i, species, b.dataset.size)).length;
          b.setAttribute('aria-pressed', String(b.dataset.size === size));
          b.setAttribute('aria-disabled', String(n === 0 && b.dataset.size !== size));
        });

        // Order, then filter, then page.
        const sorted = [...this.items].sort((a, b) => {
          const soldA = a.dataset.available === 'false', soldB = b.dataset.available === 'false';
          if (soldA !== soldB) return soldA ? 1 : -1;
          if (sort === 'price-asc') return a._price - b._price || a._order - b._order;
          if (sort === 'price-desc') return b._price - a._price || a._order - b._order;
          if (sort === 'size-asc') return a._area - b._area || a._price - b._price;
          if (sort === 'size-desc') return b._area - a._area || a._price - b._price;
          return a._order - b._order;
        });
        const matching = sorted.filter((i) => this.matches(i, species, size));
        const visible = new Set(matching.slice(0, this.state.shown));

        // FLIP: remember where each shown top was, change the layout, then glide them from there.
        const before = new Map();
        const canAnimate = animate && !this.reduce.matches && this.grid.animate;
        if (canAnimate) this.items.forEach((i) => { if (!i.hidden) before.set(i, i.getBoundingClientRect()); });

        sorted.forEach((i) => this.grid.appendChild(i));
        this.items.forEach((i) => { i.hidden = !visible.has(i); });

        if (canAnimate) {
          // Positions were read mid-flight (getBoundingClientRect includes transforms), so a new move starts from where each top is now.
          this.items.forEach((i) => i.getAnimations().forEach((a) => a.cancel()));
          const moves = [...visible].map((i) => [i, before.get(i), i.getBoundingClientRect()]);
          // Short moves glide; a top travelling more than half a screen fades in at its new place instead of flying across the page.
          const far = window.innerHeight * 0.5;
          moves.forEach(([i, was, now]) => {
            if (was && Math.abs(was.top - now.top) <= far) {
              const dx = was.left - now.left, dy = was.top - now.top;
              if (Math.abs(dx) > 1 || Math.abs(dy) > 1) {
                i.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], { duration: 560, easing: this.spring });
              }
            } else {
              i.animate([{ opacity: 0, transform: 'scale(0.97)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
            }
          });
        }

        // Status, empty state and "show more".
        const total = matching.length;
        const speciesLabel = this.speciesBtns.find((b) => b.dataset.species === species && species)?.querySelector('.wt__species-name').textContent;
        const sizeLabel = this.sizeBtns.find((b) => b.dataset.size === size && size)?.textContent.trim();
        const scope = [speciesLabel, sizeLabel].filter(Boolean).join(', ');
        const stock = matching.reduce((sum, i) => sum + i._stock, 0);
        const sold = matching.filter((i) => i._stock === 0).length;
        if (this.status) this.status.textContent = `${scope ? scope + ': ' : ''}${stock} in stock${sold ? `, ${sold} sold` : ''}`;
        if (this.empty) {
          this.empty.hidden = total !== 0;
          this.empty.querySelector('.wt__empty-text').textContent = `No ${scope || 'tops'} right now. Try another species or size.`;
        }
        const left = total - visible.size;
        if (this.moreWrap) {
          this.moreWrap.hidden = left <= 0;
          this.moreBtn.textContent = `Show ${Math.min(left, this.pageSize)} more`;
        }
      }

      openDetail(item, opener) {
        if (!this.dialog || !item) return;
        const body = this.dialog.querySelector('.wt__d-body');
        body.replaceChildren(item.querySelector('.wt__detail-src').content.cloneNode(true));
        const title = body.querySelector('.wt__d-title');
        if (title) title.id = this.dialog.getAttribute('aria-labelledby');
        const shots = [...body.querySelectorAll('.wt__d-shot')];
        const thumbs = [...body.querySelectorAll('.wt__d-thumb')];
        const stage = body.querySelector('.wt__d-stage');
        const caption = body.querySelector('.wt__d-caption');

        // Zoom: the click point becomes the zoom centre; moving the pointer pans while zoomed.
        const aim = (e) => {
          const r = stage.getBoundingClientRect();
          const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
          const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
          stage.style.setProperty('--zx', `${x}%`);
          stage.style.setProperty('--zy', `${y}%`);
        };
        const zoom = (on) => {
          if (!stage) return;
          stage.classList.toggle('is-zoomed', on);
          stage.setAttribute('aria-pressed', String(on));
          stage.setAttribute('aria-label', on ? 'Zoom out' : 'Zoom in on photo');
          if (!on) { stage.style.removeProperty('--zx'); stage.style.removeProperty('--zy'); }
        };
        if (stage) {
          stage.addEventListener('click', (e) => {
            const on = !stage.classList.contains('is-zoomed');
            if (on && e.detail > 0) aim(e); // keyboard presses (detail 0) zoom into the centre
            zoom(on);
          });
          stage.addEventListener('pointermove', (e) => { if (stage.classList.contains('is-zoomed')) aim(e); });
        }

        const show = (n) => {
          zoom(false);
          shots.forEach((s, i) => s.classList.toggle('is-active', i === n));
          thumbs.forEach((t, i) => t.setAttribute('aria-pressed', String(i === n)));
          const text = shots[n]?.dataset.caption || '';
          if (caption) { caption.textContent = text; caption.hidden = !text; }
        };
        thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
        show(0);
        this.lastOpener = opener;
        this.dialog.showModal();
        this.dialog.querySelector('.wt__d-close').focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
